import { userPreferences } from 'ducks/entities/schema'

export const agentPreferencesNormalizationSchema = {
  agentPreferences: {
    nodes: [userPreferences],
  },
}
